import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { X } from 'react-feather'
import { Container, Close } from './styles'

import Profile from '../Profile'

class Navigation extends Component {
  render() {
    const person = this.props.user
    return(
      <Container>
        <Profile
          solo
          name={person.name}
          username={person.username}
          avatar={person.avatar}
          url={person.url}
          link={true}
          seen={person.seen}
          anonymous={false} />
          <Close>
            <Link to={`/`}
              className="img-anchor">
              <X size={'100%'} />
            </Link>
            <p><Link to={`/`}>Take a step back.</Link></p>
          </Close>
      </Container>
    )
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/Components/Navigation/index.js